export class Trainings {
  private id: number;
  private libelle: string;

  constructor(Trainings: any) {
    this.id = Trainings.id;
    this.libelle = Trainings.libelle;
  }

  getId(): number {
    return this.id;
  }

  getLibelle(): string {
    return this.libelle;
  }

}